import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Display_Value_Key as dvk } from "../Create/utils";

export interface DateRangePickerProps {
  onDateRangeSelect?: any;
  filter: any;
  onChange: any;
  preSelected: any;
  onApplyStateChange?: (
    isDisabled: boolean,
    onApply: () => void,
    buttonText?: string
  ) => void;
}

const convertDateToMilliseconds = (
  dateString: string,
  isEndDate: boolean = false
) => {
  const date = new Date(dateString);
  if (isEndDate) {
    // Set time to 23:59:59.999 for end date (end of day)
    date.setHours(23, 59, 59, 999);
  }
  return date.getTime();
};

const DateRangePicker: React.FC<DateRangePickerProps> = ({
  filter,
  onChange,
  preSelected,
  onApplyStateChange,
}) => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const mtOrCt = filter.displayName === "Upload Date" ? "ct" : "mt";

  // Get today's date in YYYY-MM-DD format for max attribute
  const today = new Date().toISOString().split("T")[0];

  // Handle the change in start date
  const handleStartDateChange = (e: any) => {
    setStartDate(e.target.value);
    if (e.target.value && endDate && e.target.value > endDate) {
      setEndDate(""); // Reset end date if the start date is later
    }
  };
  function epochToFormattedDate(epochTime: number) {
    const date = new Date(epochTime); // Use milliseconds directly
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Ensure two digits
    const day = String(date.getDate()).padStart(2, "0"); // Ensure two digits
    return `${year}-${month}-${day}`; // Adjusted format for HTML input[type="date"]
  }

  // Handle the change in end date
  const handleEndDateChange = (e: any) => {
    setEndDate(e.target.value);
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" && startDate && endDate) {
      handleApply();
    }
  };

  // Pass the selected range to the parent
  const handleApply = () => {
    if (startDate && endDate) {
      const epochTimeStart = convertDateToMilliseconds(startDate, false); // Start date with 00:00:00
      const epochTimeEnd = convertDateToMilliseconds(endDate, true); // End date with 23:59:59

      const range = {
        [mtOrCt]: {
          gte: epochTimeStart,
          lte: epochTimeEnd,
        },
      };

      onChange(filter.name, range, `${startDate} / ${endDate}`);
    }
  };

  useEffect(() => {
    if (preSelected["range"]) {
      const dates = preSelected["range"];

      const sdate = epochToFormattedDate(dates[mtOrCt].gte);
      const edate = epochToFormattedDate(dates[mtOrCt].lte);

      setStartDate(sdate);
      setEndDate(edate);
    }
  }, [filter.name, preSelected]);

  // Update apply state whenever startDate or endDate changes
  useEffect(() => {
    if (onApplyStateChange) {
      onApplyStateChange(!startDate || !endDate, handleApply, "Apply");
    }
  }, [startDate, endDate, onApplyStateChange]);

  return (
    <div
      className="date-range-container"
      style={{
        height: "150px",
        overflowY: "auto",
        paddingLeft: "10px",
        paddingRight: "10px",
        minHeight: "150px",
        maxHeight: "200px",
        display: "flex",
        flexDirection: "column",
        boxSizing: "border-box",
        gap: "20px",
      }}
    >
      <div className="d-flex flex-column gap-1">
        <label htmlFor="startDate" className="form-label">
          Start Date
        </label>
        <input
          type="date"
          id="startDate"
          value={startDate}
          onChange={handleStartDateChange}
          className="form-control"
          onKeyDown={handleKeyPress}
          max={today}
        />
      </div>

      {/* End Date */}

      <div className="d-flex flex-column gap-1">
        <label htmlFor="endDate" className="form-label">
          End Date
        </label>
        <input
          type="date"
          id="endDate"
          value={endDate}
          onChange={handleEndDateChange}
          className="form-control"
          onKeyDown={handleKeyPress}
          max={today}
          min={startDate}
        />
      </div>

      {/* <hr className="w-100 my-2 divider-line" /> */}
      {/* <div className="d-flex justify-content-end">
        <button
          onClick={handleApply}
          className="btn btn-primary btn-sm text-white"
          disabled={!startDate || !endDate} // Disable button if dates are not selected
        >
          Apply
        </button>
      </div> */}
    </div>
  );
};

export default DateRangePicker;
